import { render, staticRenderFns } from "./salesSummaryChart.vue?vue&type=template&id=72828bac&"
import script from "./salesSummaryChart.vue?vue&type=script&lang=js&"
export * from "./salesSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports